module.exports = __webpack_public_path__ + "static/media/student3.8228c369.svg";